import SwipeableViews from "react-swipeable-views";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CarouselArrows from "../CarouselArrows";
import { SubscriptionSummary as Subscription } from "../../../../../types/bookingCreation";
import { RootState } from "../../../../../redux/store";
import SubscriptionSummaryCard from "./SubscriptionSummaryCard";
import { setSelectedSubscription } from "../../../../../redux/slice/subscription/subscriptionSlice";

interface Props {
  subscriptions: Subscription[];
}

function SubscriptionSummary(props: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedSubscription = useSelector((state: RootState) => state.subscription.selectedSubscription);
  const [activeStep, setActiveStep] = useState(0);
  
  useEffect(() => {
    if (props.subscriptions.length > 0 && !selectedSubscription) {
      const payload = props.subscriptions[0] || null;
      dispatch(setSelectedSubscription(payload));
    }
  }, [props.subscriptions, dispatch, selectedSubscription]);

//   useEffect(() => {
//     setActiveStep(0);
//   }, [props.serviceType]);

  const handleChangeIndex = (index: number) => {
    setActiveStep(index);
    updateFocusedItem(index);
  };

  const updateFocusedItem = (index: number) => {
    if (props.subscriptions.length > index && index >= 0) {
      const payload = props.subscriptions[index] || null;
      dispatch(setSelectedSubscription(payload));
    }
  };

  return (
    <div className="flex flex-col items-center overflow-hidden relative">
      <div className="flex flex-row relative">
        <SwipeableViews
          axis="x"
          index={activeStep}
          onChangeIndex={handleChangeIndex}
          enableMouseEvents // Enable swiping with a mouse
          className="px-5 w-[380px] overflow-visible no-scrollbar my-5"
          style={{
            padding: "0 40px",
          }}
        >
          {props.subscriptions?.map((subscriptionItem, index) => (
            <div
              key={subscriptionItem.id}
              className={`w-[280px] ${
                index === activeStep ? "blur-none opacity-100" : "blur-[1px] opacity-98"
              }`}
            >
              <SubscriptionSummaryCard
                subscriptionSummaryData={subscriptionItem}
              />
            </div>
          ))}
        </SwipeableViews>
        <CarouselArrows
          activeStep={activeStep}
          count={props.subscriptions.length}
          onStepChange={handleChangeIndex}
          previousLabel={t("subscriptions.carousel_previous")}
          nextLabel={t("subscriptions.carousel_next")}
        />
      </div>
    </div>
  );
}

export default SubscriptionSummary;
